import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { get } from 'lodash-es';
import { gql } from '@apollo/client';
import { useSubscription } from '@apollo/client/react/hooks';
import {
  BaseBox,
  FlexBox,
  PrimaryButton,
  Icons,
  Body1,
} from '@docon/docon-ui-library';
import { Image } from 'shared';

const gqlQuery = gql`
  subscription cartUrl($visitID: String!,$pincode: Int) {
    labOrder(visitID: $visitID, pincode: $pincode) {
        type
        visitID
        cartLink
        message
    }
  }`;

const Container = styled(FlexBox)`
  padding: 20px;
  height: 100%;
  background-color: white;
  flex-direction: column;
  align-items: center;

  ${Icons.CrossIcon} {
    position: absolute;
    right: 12px;
    top: 12px;
    cursor: pointer;
  }
`;

const GifContainer = styled(BaseBox)`
  flex: 1;
  max-height: 60%;
  overflow: hidden;
  width: 100%;

  ${Image} {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const Root = styled(BaseBox)`
  top: 0;
  position: absolute;
  width: 100%;
  height: 100%;

  ${Body1} { color: inherit; }
`;

function GatewayPeLab({
  visitID,
  pincode,
  onClose,
}: any) {
  const [state, setState] = useState<any>({
    loadingText: 'Preparing your cart...',
    isCartLoadingExtended: false,
    hasLab: true,
  });

  const { data, error }: any = useSubscription(gqlQuery, {
    variables: { visitID, pincode },
  });

  useEffect(() => {
    setTimeout(() => {
      setState({
        ...state,
        loadingText: 'This is usually pretty fast but seems to be taking a while right now',
        isCartLoadingExtended: true,
      });
    }, 10000);
  }, []);

  useEffect(() => {
    if (data) {
      if (data?.labOrder?.type === 'SUCCESS') {
        window.open(`${data.labOrder.cartLink}&utm_source=docon`, '_parent');
      } else {
        setState({
          ...state,
          loadingText: get(data, 'labOrder.message', '').toString(),
          hasLab: false,
        });
      }
    }
  }, [data, error]);

  let gifSrc = '';
  if (!state.isCartLoadingExtended && state.hasLab) {
    gifSrc = '/gifs/animate_500.gif';
  } else if (state.isCartLoadingExtended || !state.hasLab) {
    gifSrc = '/gifs/PECart_extended.gif';
  }

  return (
    <Root>
      <Container>
        <Icons.CrossIcon onClick={onClose} />

        <Body1 fontWeight={600} mb='20px' title='Taking you to' />
        <Image
          src='/images/pharmeasylogo/pharmeasy.svg' width='220' height='40'
          alt='pharmeasylogo'
        />

        <GifContainer>
          {
            gifSrc ? (
              <Image src={gifSrc} alt='animated' />
            ) : null
          }
        </GifContainer>

        <Body1 title={state.loadingText} p='10px 30px' fontWeight={500} />
        {
          state.isCartLoadingExtended && state.hasLab ? (
            <>
              <Body1
                mb={'24px'}
                title={"We'll notify you via SMS once your cart is ready"} px='30px' />
              <PrimaryButton
                size='small'
                m={'0 auto !important'}
                title={'Okay, Got It!'}
                onClick={onClose}
              />
            </>
          ) : null
        }
      </Container>
    </Root>

  );
}

export default GatewayPeLab;